import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
type ScrollState = {
  scrollTo?: string;
} | null;

/**
 * Every route change lands at the top of the new page, unless the navigation
 * explicitly asked to be taken to a section (state.scrollTo).
 */
export function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    const state = location.state as ScrollState;
    if (state?.scrollTo) return;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [location.pathname, location.state]);
  return null;
}